import treatmentPlanStatusConstants from '@constants/treatmentPlanStatus.constants'
import hasValue from 'utils/hasValue'

type TreatmentRefinementPlanCandidate = {
  status?: string | null
  treatment_status?: string | null
  aligner_journey_id?: number | string | null
  aligner_treatment_id?: number | string | null
  treatment_plan_id?: number | string | null
  plan_id?: number | string | null
}

export const isTreatmentRefinementPlan = (
  plan?: TreatmentRefinementPlanCandidate | null
): boolean => {
  if (!plan) return false

  const status = (plan.status ?? plan.treatment_status)?.toString().toUpperCase()
  const isRefinementStatus =
    status === treatmentPlanStatusConstants.DEACTIVATED ||
    status === treatmentPlanStatusConstants.ARCHIVED

  if (!isRefinementStatus) return false

  return (
    hasValue(plan.aligner_journey_id) ||
    hasValue(plan.aligner_treatment_id) ||
    hasValue(plan.treatment_plan_id) ||
    hasValue(plan.plan_id)
  )
}

export const hasTreatmentRefinementPlan = (
  plans?: TreatmentRefinementPlanCandidate[] | null
): boolean => Array.isArray(plans) && plans.some(isTreatmentRefinementPlan)
